import React from "react";
import "./First.css";
import { Container } from "react-bootstrap";
import hero from "../../../../Asset/hero-image-absolute.webp";
import { IoIosArrowForward } from "react-icons/io";
import firstSvg from "../../../../Asset/hero-first.svg";
import secondSvg from "../../../../Asset/hero-second.svg";
import thirdSvg from "../../../../Asset/hero-third.svg";
import fourthSvg from "../../../../Asset/hero-fourth.svg";

const First = ({ scrollToSection }) => {
  return (
    <>
      <section className="first-services-extra-section">
        <Container>
          <div className="row">
            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 service-hero-col-1">
              <div className="hero-title">
                <div className="hero-dec-text">
                  <h1 className="h1">
                    Let’s Elevate Your Unique Business with
                    <span> Personalized Software Solutions</span>
                  </h1>
                  <div className="dec-text">
                    <p>
                      At Codeffi, We have a team of 80+ innovative tech wizards
                      to build customized software solutions as unique as your
                      business.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 service-hero-col-2">
              <div className="hero-image-absolute">
                <img src={hero} className="service-hero-img" alt="main" />
              </div>
              <div className="anchor-box">
                <div
                  className="anchor-content"
                  onClick={() => scrollToSection("custom-software-development")}
                >
                  <img src={firstSvg} alt="main" />
                  <p>Custom Software Development</p>
                  <IoIosArrowForward className="arrow" />
                </div>
                <div
                  className="anchor-content ui-ux"
                  onClick={() => scrollToSection("uiux-design-development")}
                >
                  <img src={secondSvg} alt="main" />
                  <p>UI/UX Design & Development</p>
                  <IoIosArrowForward className="arrow" />
                </div>
                <div
                  className="anchor-content cloud-computing"
                  onClick={() => scrollToSection("cloud-computing")}
                >
                  <img src={thirdSvg} alt="main" />
                  <p>Cloud Computing</p>
                  <IoIosArrowForward className="arrow" />
                </div>
                <div
                  className="anchor-content iot-development"
                  onClick={() => scrollToSection("ai-iot-development")}
                >
                  <img src={fourthSvg} alt="main" />
                  <p>AI & IoT Development</p>
                  <IoIosArrowForward className="arrow" />
                </div>
              </div>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default First;
